export default __webpack_public_path__ + "static/media/room_logo.688467f2.png";